import { pickIntent } from "./helpers/ui.js";
import './assets/constants.css';const tray = "_tray_9yqvu_2";
const vertical = "_vertical_9yqvu_11";
const toast = "_toast_9yqvu_19";
const horizontal = "_horizontal_9yqvu_22";
const secondary = "_secondary_9yqvu_54";
const critical = "_critical_9yqvu_58";
const warning = "_warning_9yqvu_73";
const success = "_success_9yqvu_88";
const info = "_info_9yqvu_103";
const container = "_container_9yqvu_118";
const icon = "_icon_9yqvu_127";
const content = "_content_9yqvu_133";
const header = "_header_9yqvu_142";
const message = "_message_9yqvu_155";
const footerContainer = "_footerContainer_9yqvu_169";
const s = {
  tray,
  vertical,
  toast,
  horizontal,
  secondary,
  critical,
  warning,
  success,
  info,
  container,
  icon,
  content,
  header,
  message,
  footerContainer
};
const TOAST_TYPE = {
  VERTICAL: "vertical",
  HORIZONTAL: "horizontal"
};
const TOAST_INTENT = pickIntent(["secondary", "critical", "warning", "success", "info"]);
const TOAST_INTENT_CLASSNAME_MAP = {
  [TOAST_INTENT.SECONDARY]: s.secondary,
  [TOAST_INTENT.CRITICAL]: s.critical,
  [TOAST_INTENT.WARNING]: s.warning,
  [TOAST_INTENT.SUCCESS]: s.success,
  [TOAST_INTENT.INFO]: s.info
};
const TOAST_TYPE_CLASSNAME_MAP = {
  [TOAST_TYPE.VERTICAL]: s.vertical,
  [TOAST_TYPE.HORIZONTAL]: s.horizontal
};
export {
  TOAST_TYPE as T,
  TOAST_INTENT as a,
  TOAST_INTENT_CLASSNAME_MAP as b,
  TOAST_TYPE_CLASSNAME_MAP as c,
  s
};
